var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1381,
    height: 837,
    viewBox: "0 0 1381 837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_1824_8538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.72 510.405C1203.72 510.405 848.087 176.688 725.48 166.498C534.914 150.794 610.906 404.48 678.969 457.774C445.694 274.822 162.717 100.061 49.3252 165.399C-62.4343 229.724 112.201 364.499 112.201 364.499C335.133 320.6 636.223 631.843 693.391 669.344C744.007 702.546 824.09 682.624 846.911 648.907C898.539 572.63 851.14 451.657 819.677 388.494C818.389 386.367 817.91 383.859 818.328 381.418C818.745 378.977 820.03 376.761 821.954 375.166C823.878 373.572 826.315 372.703 828.83 372.714C831.346 372.725 833.775 373.616 835.685 375.228C885.282 410.6 984.341 479.349 1143.76 581.883C1218.92 630.213 1260.29 567.293 1203.68 510.201",
    fill: "#6C06F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.72 510.405C1203.72 510.405 848.087 176.688 725.48 166.498C534.914 150.794 610.906 404.48 678.969 457.774C445.694 274.822 162.717 100.06 49.3252 165.399C-62.4343 229.724 112.201 364.499 112.201 364.499C335.133 320.6 636.223 631.843 693.391 669.344C744.007 702.546 824.09 682.624 846.911 648.907C898.539 572.63 851.14 451.657 819.677 388.494C818.389 386.367 817.91 383.859 818.328 381.418C818.745 378.977 820.03 376.761 821.954 375.166C823.878 373.572 826.315 372.703 828.83 372.714C831.345 372.725 833.775 373.616 835.685 375.228C885.282 410.6 984.341 479.349 1143.76 581.883C1218.92 630.213 1260.29 567.293 1203.68 510.201",
    stroke: "url(#paint0_linear_1824_8538)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1824_8538",
    x: -138.529,
    y: 0.913574,
    width: 1519.06,
    height: 835.968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_1824_8538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1824_8538",
    x1: 1106.54,
    y1: -48,
    x2: 13.8527,
    y2: 205.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.f0c1900cc8570937f21221c089905cbb.svg";
export { ForwardRef as ReactComponent };